import Input from 'components/Input'
import React, { useEffect, useState } from 'react'
import { FilterBlock, RangeInputs } from 'style/Category.style'
import {
  CustomInput,
  LabelInsideInput,
  Label,
  FromToWrapper,
  FilterButton,
} from 'components/Input/Input.style'
import useInnerPage from 'store/InnerPageProvider'

export function PriceFilter(props) {
  const {
    setParam,
    params,
    sidebar: {
      loaded: sidebarLoaded,
      min_price: minPrice,
      max_price: maxPrice,
    },
  } = useInnerPage()
  const [fromValue, setFromValue] = useState(0)
  const [toValue, setToValue] = useState(0)
  const [changed, setChanged] = useState(false)

  const handleFilterButtonClick = () => {
    const saveButton = document.getElementById('saveFiltersButton')
    if (saveButton) {
      setTimeout(() => {
        saveButton.click()
      }, 300)
    }
  }
  useEffect(() => {
    setFromValue(parseInt(params.min_price) || 0)
    setToValue(parseInt(params.max_price) || 10000)
  }, [params.max_price, params.min_price])

  useEffect(() => {
    if (!sidebarLoaded || !fromValue) return
    if (fromValue > maxPrice || fromValue < minPrice || fromValue > toValue) {
      return setFromValue(minPrice)
    }
    const deb = setTimeout(() => {
      if (!changed) return
      setParam('min_price', fromValue)
    }, 300)
    return () => clearTimeout(deb)
    // eslint-disable-next-line
  }, [fromValue, sidebarLoaded])

  useEffect(() => {
    if (!sidebarLoaded || !toValue) return
    if (toValue > maxPrice || toValue < minPrice || toValue < fromValue) {
      return setToValue(maxPrice)
    }
    const deb = setTimeout(() => {
      if (!changed) return
      setParam('max_price', toValue)
    }, 300)
    return () => clearTimeout(deb)
    // eslint-disable-next-line
  }, [toValue, sidebarLoaded])

  return (
    <FilterBlock>
      <h3>ფასი</h3>
      <RangeInputs>
        <FromToWrapper>
          <LabelInsideInput>
            <CustomInput
              type="number"
              key={fromValue}
              defaultValue={fromValue}
              onBlur={e => {
                setChanged(true)
                setFromValue(parseInt(e.target.value))
              }}
            />
            <Label>-დან</Label>
          </LabelInsideInput>

          <LabelInsideInput>
            <CustomInput
              type="number"
              key={toValue}
              defaultValue={toValue}
              onBlur={e => {
                setChanged(true)
                setToValue(parseInt(e.target.value))
              }}
            />
            <Label>-მდე</Label>
          </LabelInsideInput>
        </FromToWrapper>
        <Input
          component="range"
          from={minPrice}
          to={maxPrice}
          fromValue={fromValue}
          toValue={toValue}
          onFromChange={val => {
            setChanged(true)
            setFromValue(parseInt(val))
          }}
          onToChange={val => {
            setChanged(true)
            setToValue(parseInt(val))
          }}
        />
      </RangeInputs>
      <span>
        ფასი: {fromValue}₾ - {toValue}₾
      </span>
      <FilterButton onClick={handleFilterButtonClick}>ძებნა</FilterButton>
    </FilterBlock>
  )
}
